import Vue from "vue";
import { ref, computed } from "@vue/composition-api";

import { getMutilCardByNg } from "@/apis/product";
import { getUserBenefit } from "@/apis/home";
import { storage, jsonSafeParse } from "@/utils";
import { useStore } from "@/components/use/base";

import { getIndexCategory, getIndexClassList } from "@/apis/product";

const vm = Vue.prototype;

export const DEFAULT_CURRENT_GROUP = {
  children: []
};

export default function useMoreCard() {
  const card = ref({});
  const categoryList = ref([]);
  const currentCard = ref({});
  const mainCardList = ref([]);
  const currentGroup = ref(DEFAULT_CURRENT_GROUP);

  const store = useStore();

  const namespace = computed(() => store.state.namespace);
  const isMember = computed(() => store.state.isMember);

  // 获取前台分类
  const initMoreCard = async page => {
    const { data } = await getUserBenefit({
      card_status:
        vm.$getConfigValue("USER_BENEFIT_STAT_CARD_LIST") || undefined
    });
    card.value = data;
    const namespaceValue =
      page ||
      vm.$getConfigValue("MORE_CARD_NAMESPACE") ||
      currentCard.value.page;
    const { data: categoriesData } = await getIndexCategory({
      namespace: namespaceValue,
      opened_page: "member",
      source: "default"
    });
    const { data: productData } = await getIndexClassList({
      title: categoriesData.map(v => v.name).join(","),
      opened_page: "member",
      namespace: namespaceValue
    });
    const pageInfo = categoriesData.map(value => ({
      ...value,
      productInfo: productData[value.name] || []
    }));
    categoryList.value = pageInfo.filter(
      item => item.display_code !== "onlineOrdering"
    );
  };

  const initMoreCardForVisitor = async page => {
    const namespaceValue =
      page ||
      vm.$getConfigValue("MORE_CARD_NAMESPACE") ||
      currentCard.value.page;
    const { data: categoriesData } = await getIndexCategory({
      namespace: namespaceValue,
      opened_page: "member",
      source: "default"
    });
    const { data: productData } = await getIndexClassList({
      title: categoriesData.map(v => v.name).join(","),
      opened_page: "member",
      namespace: namespaceValue
    });
    const pageInfo = categoriesData.map(value => ({
      ...value,
      productInfo: productData[value.name] || []
    }));
    categoryList.value = pageInfo.filter(
      item => item.display_code !== "onlineOrdering"
    );
  };

  const setStoreAndStorage = async (token, namespace) => {
    storage.setItem("token", token);
    storage.setItem("namespace", namespace);
    store.commit("changeState", {
      token: token,
      namespace: namespace
    });
    await store.dispatch("fetchNamespace");
    await store.dispatch("fetchUserInfo");
  };

  // 获取用户卡映射
  const getCardList = async () => {
    const packageMap = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
    const { data } = await getMutilCardByNg();

    const arr = [];
    const handleArr = data.map(item => {
      return {
        ...item,
        ...packageMap[item.namespace]
      };
    });
    for (let item of handleArr) {
      const index = arr.findIndex(v => v.group === item.group);
      if (index !== -1) {
        arr[index].children.unshift(item);
        arr[index].namespace.push(item.namespace);
      } else {
        arr.unshift({
          order: item.order,
          server: item.server,
          group: item.group,
          page: item.page,
          namespace: [item.namespace],
          children: [item]
        });
      }
    }
    mainCardList.value = arr;
    if (isMember.value) {
      currentGroup.value =
        arr.find(v => v.namespace.includes(namespace.value)) ||
        DEFAULT_CURRENT_GROUP;
      currentCard.value = currentGroup.value.children.find(
        v => v.namespace === namespace.value
      );
    } else {
      currentGroup.value = arr[0] || DEFAULT_CURRENT_GROUP;
      currentCard.value = arr[0].children[0];
      setStoreAndStorage(
        arr[0].children[0].token,
        arr[0].children[0].namespace
      );
    }
  };

  return {
    getCardList,
    initMoreCard,
    setStoreAndStorage,
    initMoreCardForVisitor,
    card,
    categoryList,
    currentCard,
    mainCardList,
    currentGroup
  };
}
